<template>
  <div id="AddSemesterDialog">
    <v-btn  :ripple="false"  icon small dark color="error"   slot="activator" @click="showRemoveCollegeDialog(user)" >
      <v-icon color="red" >mdi-delete</v-icon>
    </v-btn>
    <v-dialog
      v-model="RemoveCollegeDialog"
      width="400"
      persistent
      style="borderRadius:5px; zIndex:2"
    >
        <v-card >
            <v-toolbar  color="red elevation-0" dark>
            <v-icon color="white ">mdi-delete</v-icon>
            <v-toolbar-title class="white--text ml-1">Remove College </v-toolbar-title>

          </v-toolbar>
          
          <v-card-text>
          Are you sure you want to remove <span class="font-weight-medium">{{college.college_name}}</span> ?
         <p class="mt-1 "> All your courses will be deleted!</p>
          </v-card-text>
        

       
          <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click.native="RemoveCollegeDialog = false">Cancel</v-btn>
          <v-btn color="red"  small text @click.native="removeCollege()">Remove</v-btn>
        </v-card-actions>
          <div style="flex: 1 1 auto;"></div>
        </v-card>
      </v-dialog>
  </div>

</template>

<script>
  export default {
    props: ['college'],
     data() {
      return {
        modal: false,
        alert: false,
        RemoveCollegeDialog: false,
      }
    },
    methods: {
      showRemoveCollegeDialog(user) {
        if(user !== null && user !== undefined ){
          this.RemoveCollegeDialog = true
        }
        else {
          this.alert = true
          console.log('not logged in')
        }
      },
      removeCollege () {
        this.$store.dispatch('setRemoveCollege', this.college.id)
        this.RemoveCollegeDialog = false
         this.$router.go('-1')
        //   if( screen.width >= 960) {
        //   this.$router.push('/dashboard')
        // } else {
        //   this.$router.push('/dashboard/mygrades')
        // }
        
      }
    },
    computed : {
      user () {
        return this.$store.getters.user
      }
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/Dashboard/Grades/Colleges/RemoveCollegeDialog.vue